export class GraphqlMiddlewareCache {
  cache = {};
  asyncDataKeyMap = {};
  keys = [];
  maxSize;
  constructor(maxSize = 100) {
    this.maxSize = maxSize;
  }
  set(key, value, asyncDataKey) {
    if (Object.prototype.hasOwnProperty.call(this.cache, key)) {
      const index = this.keys.indexOf(key);
      if (index > -1) {
        this.keys.splice(index, 1);
      }
    } else if (this.keys.length >= this.maxSize) {
      const oldestKey = this.keys.shift();
      if (oldestKey !== void 0) {
        delete this.cache[oldestKey];
        delete this.asyncDataKeyMap[oldestKey];
      }
    }
    this.cache[key] = value;
    this.keys.push(key);
    if (asyncDataKey) {
      if (!Object.prototype.hasOwnProperty.call(
        this.asyncDataKeyMap,
        asyncDataKey
      )) {
        this.asyncDataKeyMap[asyncDataKey] = [];
      }
      this.asyncDataKeyMap[asyncDataKey].push(key);
    }
  }
  get(key) {
    const value = this.cache[key];
    if (value !== void 0) {
      const index = this.keys.indexOf(key);
      if (index > -1) {
        this.keys.splice(index, 1);
        this.keys.push(key);
      }
      return value;
    }
    return void 0;
  }
  purge() {
    this.cache = {};
    this.keys = [];
    this.asyncDataKeyMap = {};
  }
  purgeAsyncDataKey(asyncDataKey) {
    const keys = this.asyncDataKeyMap[asyncDataKey];
    if (keys && keys.length) {
      keys.forEach((key) => {
        this.remove(key);
      });
    }
  }
  remove(key) {
    if (Object.prototype.hasOwnProperty.call(this.cache, key)) {
      delete this.cache[key];
      const index = this.keys.indexOf(key);
      if (index > -1) {
        this.keys.splice(index, 1);
      }
      return true;
    }
    return false;
  }
}
